<template>
  <verification-layout>
    <template slot="content">
      <div style="width: 1024px" class="elevation-5 mx-auto my-5">
        <v-dialog v-model="recaptchDialog" width="500" persistent>
          <v-card>
            <v-form v-model="valid">
              <v-card-text class="recaptcha-container">
                <v-text-field
                  label="Nº do MTR"
                  v-model="mtrNumber"
                  required
                  :rules="[validationRules.required]"
                ></v-text-field>
                <!-- <div class="d-flex align-center">
                  <div class="flex-1">
                    <v-btn color="primary" @click="executeRecaptcha">
                      Executar reCAPTCHA
                    </v-btn>
                  </div>
                  <div class="flex-1 justify-center align-center">
                    <img
                      src="@/assets/recaptcha-icon.svg"
                      alt="reCAPTCHA"
                      style="width: 32px; height: 32px"
                    />
                  </div>
                </div> -->

                <p v-if="recaptchaError" class="text-error">
                  {{ recaptchaError }}
                </p>
              </v-card-text>

              <v-card-actions class="justify-end">
                <v-btn :to="'/login'">Cancelar</v-btn>
                <v-spacer />
                <v-btn color="primary" @click="previewMtr" :disabled="!valid">
                  Consultar
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <pdf
          v-if="!recaptchDialog && pdfLink"
          :src="pdfLink"
          style="width: 100%"
        ></pdf>
      </div>
      <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Aguarde, estamos carregando o MTR
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </verification-layout>
</template>

<script
  src="https://www.google.com/recaptcha/api.js?render="
  +this.recaptchaPublicKey()
></script>
<script>
import mtrService from "@/services/mtr-service";
import pdf from "vue-pdf";
import VerificationLayout from "@/layouts/VerificationLayout";
import validationRules from "@/mixins/validation-rules";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "VerificaMtr",
  components: {
    pdf,
    VerificationLayout,
    VueRecaptcha,
  },
  data() {
    return {
      validationRules,
      mtrNumber: this.$route.query.mtr,
      pdfLink: null,
      recaptchDialog: true,
      loadingDialog: false,
      gTokenRecaptcha: null,
      valid: false,
      recaptchaError: null,
      isRecaptchaLoaded: false, // Para controlar se o reCAPTCHA foi carregado
    };
  },
  computed: {
    recaptchaPublicKey() {
      return process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY;
    },
  },
  mounted() {
    this.loadRecaptcha();
  },
  methods: {
    loadRecaptcha() {
      if (document.getElementById("recaptcha-script")) {
        this.isRecaptchaLoaded = true;
        return;
      }

      const script = document.createElement("script");
      script.id = "recaptcha-script";
      script.src =
        "https://www.google.com/recaptcha/api.js?render=" +
        this.recaptchaPublicKey;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        this.isRecaptchaLoaded = true;
        console.log("✅ reCAPTCHA v3 carregado com sucesso!");
      };
      document.head.appendChild(script);
    },

    async executeRecaptcha() {
      if (this.isRecaptchaLoaded && window.grecaptcha) {
        try {
          console.log("🔄 Inicializando reCAPTCHA...");
          await new Promise((resolve) => {
            if (window.grecaptcha.enterprise) {
              window.grecaptcha.enterprise.ready(resolve);
            } else {
              window.grecaptcha.ready(resolve);
            }
          });
          console.log("✅ reCAPTCHA pronto para execução.");

          let token = null;
          if (!window.grecaptcha.enterprise) {
            token = await window.grecaptcha.execute(this.recaptchaPublicKey, {
              action: "MTR_VERIFICATION",
            });
          } else {
            token = await window.grecaptcha.enterprise.execute(
              this.recaptchaPublicKey,
              {
                action: "MTR_VERIFICATION",
              }
            );
          }

          if (!token) {
            throw new Error("❌ Nenhum token gerado.");
          }

          console.log("✅ Token reCAPTCHA gerado:");
          this.gTokenRecaptcha = token;
        } catch (error) {
          this.recaptchaError =
            "❌ Erro ao executar reCAPTCHA: " + error.message;
          console.error(this.recaptchaError);
        }
      }
    },
    async previewMtr() {
      await this.executeRecaptcha();
      //console de verificação do recaptcha
      if (!this.gTokenRecaptcha) {
        console.error(
          "🚨 Token do reCAPTCHA ausente. Execute o reCAPTCHA antes."
        );
        return;
      }

      this.recaptchDialog = false;
      this.loadingDialog = true;
      console.log("🔍 Consultando MTR...");
      mtrService
        .qrcodePreview(this.mtrNumber, this.gTokenRecaptcha)
        .then((response) => {
          this.pdfLink = response.data;
        })
        .catch(() => {
          this.recaptchaError =
            "Número de MTR inválido. Verifique e tente novamente.";
          this.$store.dispatch("application/toggleSnackbar", {
            show: true,
            timeout: 6000,
            color: "error",
            message: this.recaptchaError,
            messageIcon: "mdi-alert-outline",
          });
        })
        .finally(() => {
          this.loadingDialog = false;
        });
    },
  },
};
</script>
